exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.glyphicon-ok-sign[data-v-bb3b36c0] {\n  color: green;\n}\n.glyphicon-remove-sign[data-v-bb3b36c0] {\n  color: red;\n}\n", "", {"version":3,"sources":["/app/src/components/OrderTable/components/tdStatus.vue"],"names":[],"mappings":";AACA;EACE,aAAa;CACd;AACD;EACE,WAAW;CACZ","file":"tdStatus.vue","sourcesContent":["\n.glyphicon-ok-sign[data-v-bb3b36c0] {\n  color: green;\n}\n.glyphicon-remove-sign[data-v-bb3b36c0] {\n  color: red;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-bb3b36c0","scoped":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/OrderTable/components/tdStatus.vue
// module id = eybc
// module chunks = 0